export const HOME_SLUG = 'home';

export const DATA_ROOT_PATH = '/andmed';
export const SHARE_ROOT_PATH = '/jaga';

export const METRICS_PATH = DATA_ROOT_PATH + '/moodikud';
export const STATISTICS_PATH = DATA_ROOT_PATH + '/statistika';

export const SHARE_METRICS_PATH = SHARE_ROOT_PATH + '/moodikud';
export const SHARE_STATISTICS_PATH = SHARE_ROOT_PATH + '/statistika';

export const DASHBOARD_PATH = '/toolaud';

export const ADMIN_ROOT_PATH = '/admin';
